import { Markup } from '@/components/Markup';
import { Tiktok } from './Tiktok';
import React from 'react';

export const StandaloneTiktok: typeof Markup = React.memo((props) => {
  return <Tiktok {...props} />;
});

StandaloneTiktok.displayName = 'StandaloneTiktok';
